module.exports = __webpack_public_path__ + "static/media/eyes_right.1e08b973.svg";